import {
  MenuSelect, NoResults, Pagination, SearchBox, Stats, WhiteInstantSearchBuilder,
} from '@white-nl/instantsearch-components';
import { Hit, Loading } from '../../components/search/results';
import { ClearIndicator, DropdownIndicator } from '../../components/ui/view/React-select';
import { addDefaultItem } from '../../utils/TransformUtils';

import './site-search.css';

const settings = document.getElementById('site-search')?.dataset || null;
const whiteInstantSearchCatalog = new WhiteInstantSearchBuilder();
if (settings) {
  const indexName = settings.indexName || '';
  const apiUrl = window.Craft.getSiteUrl('api/react/search');

  fetch(apiUrl, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((res) => res.json())
    .then((data) => {
      const {
        translates,
      } = data;

      const {
        search,
        pagination,
      } = translates;

      whiteInstantSearchCatalog
        .withSearchkit(
          indexName,
          settings.publicUrl || '',
          settings.jwt || '',
          settings.refreshUrl || '',
        )
        .setRouting({
          stateToRoute(uiState) {
            const indexUiState = uiState[indexName] || {};
            return {
              type: indexUiState.menu?.type,
              q: indexUiState.query,
            };
          },
          routeToState(routeState) {
            return {
              [indexName]: {
                menu: {
                  type: routeState.type,
                },
                query: routeState.q,
              },
            };
          },
        })
        .addMenu(
          [{
            settings: {
              attribute: 'type',
              limit: 999,
              classNames: {
                control: () => 'dropdown-select',
                menu: () => 'dropdown-list',
              },
              isSearchable: false,
              isClearable: true,
              unstyled: true,
              components: {
                ClearIndicator,
                DropdownIndicator,
              },
              transformItems: (items) => addDefaultItem(items, window.Craft.t(search, 'All types', {})),
              translations: {
                defaultOptionText: window.Craft.t(search, 'All types', {}),
              },
            },
            component: MenuSelect,
          }],
          '#white-instant-refinements',
        )
        .addSearchingComponent([
          {
            settings: {
              placeholder: '',
            },
            component: SearchBox,
          },
        ])
        .addStatsComponent(
          [
            {
              settings: {
                translations: {
                  resultsFound: window.Craft.t(search, 'results found', {}),
                  resultFound: window.Craft.t(search, 'result found', {}),
                },
              },
              component: Stats,
            },
          ],
          '.hits-count',
        )
        .addHitComponent(
          [
            {
              settings: {
                noResults: {
                  translations: {
                    noResults: window.Craft.t(search, 'Sorry, we can\'t find any content!', {}),
                    refinements: window.Craft.t(search, 'Try to choose another category or filter.', {}),
                    query: window.Craft.t(search, 'Please try another query.', {}),
                  },
                },
              },
              component: Hit,
              loadingComponent: Loading,
              noResultsComponent: NoResults,
            },
          ],
          '#white-instant-search-hits',
        )
        .setHitsPerPage(12)
        .addPaginationComponent([
          {
            settings: {
              classNames: {
                noRefinementRoot: 'hidden',
                list: 'pagination-list',
                pageItem: 'pagination-item',
                link: 'pagination-link',
                previousPageItem: 'pagination-link pagination-link-prev',
                selectedItem: 'active',
                disabledItem: 'disabled',
                nextPageItem: 'pagination-link pagination-link-next',
              },
              translations: {
                previousPageItemText: window.Craft.t(pagination, 'Previous', {}),
                nextPageItemText: window.Craft.t(pagination, 'Next', {}),
              },
              showFirst: false,
              showLast: false,
            },
            component: Pagination,
          }])
        .setScrolling({
          includeAttributes: ['page'],
        });
      whiteInstantSearchCatalog
        .build()
        .show();
    });
}
